import {
    Chart as ChartJS,
    Tooltip,
    Legend,
  } from 'chart.js';
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(
    Tooltip,
    Legend,
    ChartDataLabels
);
export const isEmpty = (obj) => {
    return Object.keys(obj).length === 0;
}

export const themeDetector = (obj) => {
    const getStoredTheme = () => localStorage.getItem('theme');
    const setStoredTheme = theme => localStorage.setItem('theme', theme);
    // Add listener to update styles
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', e => {
        const storedTheme = getStoredTheme()
        const theme = storedTheme ? storedTheme : (e.matches ? 'dark' : 'light');
        const shouldAdd = theme === 'dark' ? true : false;
        document.documentElement.setAttribute('data-bs-theme', e.matches ? 'dark' : 'light');
        document.documentElement.classList.toggle('ion-palette-dark', shouldAdd);
        setStoredTheme(theme);
    });
  
    const storedTheme = getStoredTheme()
    const theme = storedTheme ? storedTheme : (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
    const shouldAdd = theme === 'dark' ? true : false;
    // Setup dark/light mode for the first time
    document.documentElement.setAttribute('data-bs-theme', theme);
    document.documentElement.classList.toggle('ion-palette-dark', shouldAdd);
    setStoredTheme(theme);
  
    // Remove listener
    return () => {
      window.matchMedia('(prefers-color-scheme: dark)').removeEventListener('change', () => {
      });
    }
}

export const checkDarkTheme = (obj) => {
    const getStoredTheme = () => localStorage.getItem('theme');
  
    const storedTheme = getStoredTheme()
    const theme = storedTheme ? storedTheme : (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
    const shouldAdd = theme === 'dark' ? true : false;
    return shouldAdd;
}

export const chartDarkMode = () => {
    ChartJS.defaults.color = "rgba(255,255,255,1)";
    ChartJS.defaults.borderColor = "rgba(255,255,255,1)";
}


//Debug log with classname and message/object
/*export const logD = (name, obj) => {
    if(conf.debug) {
        console.log(name);
        console.log(obj);
    }
}*/

/*function sendError(error) {
    fetch(conf.BEprotocol + '://' + conf.BEhost + ':' + conf.BEport + '/' + conf.BEcontext + '/rest/error/send', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({"name": conf.name,
                              "version":conf.version,
                              "host":conf.host,
                              "port":conf.port,
                              "context":conf.context,
                              "error":error,
                            }),
    })
    .then((response) => response.json());
}

//Debug log with classname and message/object
export const logE = (error, summary) => {
    if(conf.error) {
        console.error(error);
        console.error(summary);
        sendError(error.stack);
    }
}*/

export default function Util() {

}